import React from 'react';
import moment from 'moment';

import { env } from '~/commons/config';

import ListResource from './ListResource.jsx';

const api = '/api/core/taxations';

const ListTaxations = () => (
  <ListResource
    {...{
      searchable: true,
      api,
      sort: { refCode: 1 },
      actions: {
        fileImport: true,
        fileExport: true,
      },
      cols: [
        { key: 'orgId', children: 'Organization ID', sortable: true },
        { key: 'rate' },
        {
          key: 'startAt',
          getter: (v) => (v ? moment(v).format(env.f.dt) : ''),
        },
      ],
    }}
  />
);

export default ListTaxations;
